import { Component, Input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { KKM_REGISTER_METHODS } from './kkm-register-methods.config';
import { SharedModule } from '../../../../shared/shared.module';
import { KkmRegisterMethod } from './kkm-register-methods.types';
import { IsnaEnabledService } from '../../shared/services/isna-enabled.service';

@UntilDestroy()
@Component({
  selector: 'tax-kkm-register-methods',
  templateUrl: './kkm-register-methods.component.html',
  styleUrls: ['./kkm-register-methods.component.sass'],
  standalone: true,
  imports: [
    SharedModule,
    RouterLink,
  ],
})

export class KkmRegisterMethodsComponent {
  @Input() hasRetailPlace = false;
  showDropdown = false;
  readonly kkmRegisterMethods = KKM_REGISTER_METHODS;

  constructor(
    private router: Router,
    private isnaEnabledService: IsnaEnabledService,
  ) {}

  goToRegisterProcess(kkmRegisterMethod: KkmRegisterMethod): void {
    if (kkmRegisterMethod.name === 'add') this.router.navigate([kkmRegisterMethod.link]);
    else {
      this.isnaEnabledService.checkIsnaEnabled().pipe(untilDestroyed(this))
        .subscribe({
          next: () => this.router.navigateByUrl(`${kkmRegisterMethod.link}?isChangingOfd=true`),
        });
    }
  }
}
